import { BLOG_API_URL } from '@/config'
import { sendError } from '@/utils/rollbar'

export default async function fetchAPI(query = '', { variables }) {
  const headers = { 'Content-Type': 'application/json' }

  // WPGraphQL Plugin must be enabled
  const res = await fetch(`${BLOG_API_URL}/graphql`, {
    headers,
    method: 'POST',
    body: JSON.stringify({
      query,
      variables,
    }),
  })

  const json = await res.json()
  if (json.errors) {
    sendError(json.errors, 'Wordpress client API error')
    throw new Error('Failed to fetch API')
  }
  return json.data
}
